<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Soll die Datei {{ fileInfo.fileName }} wirklich gelöscht werden?</h4>
        <!-- <h6>{{this.translate.data['USER'] | translate}}: {{userName}}</h6> -->
    </div>

    <div class="card-body">
        <form [formGroup]="fileDeleteForm">
            <!-- <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                <input matInput hidden formControlName="id" readonly>
            </mat-form-field> -->
    
            <mat-form-field class="example-full-width">
                <input matInput formControlName="fileName" readonly>
                <!-- <button mat-button color="primary"  matSuffix mat-icon-button (click)="deleteUser(userDto.id)"> 
                    <mat-icon>delete</mat-icon>
                </button> -->
            </mat-form-field>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Abbrechen"
                (click)="cancel()" >Abbruch</button>
            <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="deleteFile(fileInfo.fileName)" color="primary">Datei löschen</button>
        </form>
    </div>
</div>
